import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Formik, Form } from 'formik'
import {
  Button, TextField, Grid,
} from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import * as Yup from 'yup'
import { useDispatch, useSelector } from 'react-redux'
import { resetPasswordByUsername } from '../../../app/slices/userSlice'
import { selectorLoading } from '../../../app/slices/loadingSlice'

const initialValues = {
  username: '',
}

const useStyles = makeStyles((theme) => ({
  paperForm: {
    padding: theme.spacing(1, 2),
  },
  titleSection: {
    marginTop: theme.spacing(4),
    width: '100%',
    fontSize: '18px',
  },
  item: {
    padding: theme.spacing(1.5, 0),
  },
  username: {
    height: theme.spacing(9),
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    margin: theme.spacing(2, 0),
  },
  buttonSend: {
    width: '100%',
    backgroundColor: '#f9b233',
    color: '#ffffff',
    fontSize: '18px',
    padding: '16px 0',
    borderRadius: '10px',
  },
}))

const SendUserStep = ({ setActiveStep }) => {
  const { t } = useTranslation()
  const classes = useStyles()
  const dispatch = useDispatch()
  const loading = useSelector(selectorLoading)

  const handleSend = (fields) => {
    const formData = {
      userName: fields.username,
    }
    dispatch(resetPasswordByUsername(t, formData, () => { setActiveStep('SendCodeStep') }))
  }

  const validationSchema = Yup.object().shape({
    username: Yup.string()
      .length(10, t('must_be_exactly_ten_characters'))
      .required(`${t('username')} ${t('required')}`),
  })

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(fields) => handleSend(fields)}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        touched,
        values,
      }) => (
        <Form>
          <Grid
            container
            justify="center"
            direction="row"
            alignItems="center"
            style={{ margin: '0 auto' }}
          >
            <label htmlFor="forgetPass" className={classes.titleSection}>
              {' '}
              {t('please_enter_username')}
            </label>

            <Grid item xs={12} classes={{ root: classes.item }}>
              <TextField
                id="forgetPass"
                classes={{ root: classes.username }}
                error={Boolean(touched.username && errors.username)}
                dir="rtl"
                InputLabelProps={{ dir: 'ltr' }}
                helperText={touched.username && errors.username}
                // label={t('username')}
                placeholder={t('national_code')}
                margin="normal"
                name="username"
                onBlur={handleBlur}
                onChange={(e) => (e.target.validity.valid ? handleChange(e) : undefined)}
                type="text"
                value={values.username}
                variant="outlined"
                fullWidth
                autoFocus
                inputProps={{
                  maxLength: 10,
                  pattern: '[0-9]*',
                }}
              />
            </Grid>
          </Grid>
          <Grid classes={{ root: classes.buttonContainer }}>
            <Button
              variant="contained"
              // color="primary"
              classes={{ root: classes.buttonSend }}
              disabled={!!loading}
              type="submit"
              size="large"
            >
              {t('send')}
            </Button>
          </Grid>
        </Form>
      )}
    </Formik>
  )
}

SendUserStep.propTypes = {
  setActiveStep: PropTypes.func,
}

export default SendUserStep
